import { useSelector } from "react-redux";

export default function usePermission() {
    const permissions = useSelector((state) => state.permissions.list);

    // Check single permission
    const hasPermission = (perm) => permissions?.includes(perm);

    // Check one of many permissions
    const hasAnyPermission = (permArray = []) =>
        permArray.some((p) => permissions?.includes(p));

    // Check all permissions
    const hasAllPermissions = (permArray = []) =>
        permArray.every((p) => permissions?.includes(p));

    return {
        hasPermission,
        hasAnyPermission,
        hasAllPermissions,
    };
}
